import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import moment from 'moment'
import ElementUI from 'element-ui' // 引入核心js组件
import 'element-ui/lib/theme-chalk/index.css'// 引入依赖的样式
import '@/assets/css/global-scrollbar.css'
import md5 from 'js-md5'
// import menuLayout from '@/components/menu-layout'
// import Footer from '@/components/footer'
import menuLayout from '@/components/menu-layoutV2'
import Footer from '@/components/footerV2'
import breadcrumb from '@/components/breadcrumb'
import rightSuspension from '@/components/right-suspension'
import global from '@/components/common/global'
import {parseTime, secondConversion} from '@/utils/time'
import websocket from '@/utils/websocket'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import VEmojiPicker from 'v-emoji-picker'
import './utils/directives.js'
// import 'lib-flexible'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import echarts from 'echarts'
import echartsGL from 'echarts-gl' // 引入echarts
import VueCropper from 'vue-cropper'
import loginModal from '@/utils/loginModalV2'
import '@/assets/css/global.css'
Vue.use(VueCropper)
Vue.prototype.$echartsGL = echartsGL // 引入组件（将echarts注册为全局）

ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.Dialog.props.closeOnPressEscape.default = false
var VueCookie = require('vue-cookie')
Vue.use(VueDirectiveImagePreviewer)
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI) // 引用
Vue.use(VueCookie)
Vue.use(VEmojiPicker)
Vue.use(rightSuspension)
Vue.use(loginModal)
Vue.config.productionTip = false
Vue.component('menuLayout', menuLayout)
Vue.component('Footer', Footer)
Vue.component('breadcrumb', breadcrumb)
Vue.prototype.$global = global
Vue.prototype.$moment = moment
Vue.prototype.$md5 = md5
Vue.prototype.parseTime = parseTime
Vue.prototype.secondConversion = secondConversion
Vue.prototype.$websocket = websocket
Vue.prototype.$websocket = websocket
Vue.prototype.$echarts = echarts

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
Vue.directive('real-img', async function (el, binding) { // 指令名称为：real-img
  let imgURL = binding.value// 获取图片地址
  if (imgURL) {
    let exist = await imageIsExist(imgURL)
    if (exist) {
      el.setAttribute('src', imgURL)
    }
  }
})
Vue.directive('right-click', {
  bind: function (el, binding) {
    el.addEventListener('contextmenu', function (event) {
      event.preventDefault()
    })
  }
})
Vue.use(VueQuillEditor)
/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function (url) {
  return new Promise((resolve) => {
    var img = new Image()
    img.onload = function () {
      if (this.complete === true) {
        resolve(true)
        img = null
      }
    }
    img.onerror = function () {
      resolve(false)
      img = null
    }
    img.src = url
  })
}

// 定义路由分组，提高可读性和可维护性
const hideNavMenuRoutes = [
  'login', 'mistakes', 'mistakesdetail', 'startexam', 'viewscore', 'myclass', 'startStudy',
  'enroll', 'enrollUser', 'pay', 'enrollUserInfo', 'paySuccess', 'companyPay', 'checkPay', 'updateEnrollUserInfo',
  'statistics', 'statistics1', 'register', 'orderpay', 'orderpaySuccess', 'subscriberStartStudy', 'liveroom', 'liveplay', 'forgotpassword',
  'wechatpayment', 'paymentsuccess', 'paymenterror', 'goodspay'
]
router.beforeEach((to, from, next) => {
  // 设置默认值
  // 使用数组和includes方法简化逻辑，提高代码的可扩展性
  if (hideNavMenuRoutes.includes(to.name)) {
    to.meta.showNavMenu = false
  } else {
    to.meta.showNavMenu = true
  }
  // 动态修改页面title，保留原有功能
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
